<template>
  <div id="pageProfie">
    <v-container grid-list-md fluid>
      <v-row>
        <v-col cols="12" md="6" xs="12">
          <v-card>
            <v-card-title>
              <h2 class="title blue--text">1. Dados pessoais</h2>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6" xs="12">
                  <v-text-field
                    v-model="model.name"
                    label="Nome"
                    :error="model.errors && model.errors.name"
                  ></v-text-field>
                </v-col>
                <v-col md="6" xs="12">
                  <v-text-field
                    v-model="model.cpf"
                    v-mask="'###.###.###-##'"
                    label="CPF"
                    type="tel"
                    :disabled="true"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6" xs="12">
                  <v-text-field
                    v-model="model.email"
                    label="E-mail"
                    type="email"
                    :error="model.errors && model.errors.email"
                    :error-messages="
                      model.errors && model.errors.email
                        ? 'Já existe uma conta cadastrada com esse e-mail'
                        : ''
                    "
                  ></v-text-field>
                </v-col>
                <v-col md="6" xs="12">
                  <v-text-field
                    v-model="model.phone"
                    v-mask="'(##) (##) ####-#####'"
                    label="Phone (com DDI e DDD)"
                    type="tel"
                    :disabled="true"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mt-2">
            <v-card-title>
              <h2 class="title blue--text">2. Endereço de Correspondência</h2>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6" xs="12">
                  <v-text-field
                    v-model="model.address.zipcode"
                    @input="findCep"
                    label="CEP"
                    type="tel"
                  ></v-text-field>
                </v-col>
                <v-col md="6" xs="12">
                  <v-text-field
                    v-model="model.address.address"
                    label="Endereço"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6" xs="12">
                  <v-text-field
                    v-model="model.address.number"
                    label="Número"
                  ></v-text-field>
                </v-col>
                <v-col md="6" xs="12">
                  <v-text-field
                    v-model="model.address.complement"
                    label="Complemento"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6" xs="12">
                  <v-text-field
                    v-model="model.address.neighborhood"
                    label="Bairro"
                  ></v-text-field>
                </v-col>
                <v-col md="6" xs="12">
                  <v-text-field
                    v-model="model.address.state"
                    label="Estado"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6" xs="12">
                  <v-text-field
                    v-model="model.address.city"
                    label="Cidade"
                    name="city"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6" xs="12">
          <v-card>
            <v-card-title>
              <h2 class="title blue--text">3. Foto do perfil</h2>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col xs="4" class="profile-photo">
                  <div v-if="previewImage">
                    <br />
                    <div style="height: 360px">
                      <v-img :src="previewImage" alt="Logo"></v-img>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="4">
                  <v-col cols="12" style="text-align: center">
                    <p>
                      Faça upload de uma foto para seu perfil público com
                      dimensões minimas de 360 pixels de largura e altura no
                      formato JPG ou PNG.
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      @change="getPreviewImage"
                      accept="image/png, image/jpeg"
                      prepend-icon="fa-camera"
                      label="Enviar logo"
                    >
                    </v-file-input>
                  </v-col>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="mt-2">
            <v-card-title>
              <h2 class="title blue--text">4. Alteração de senha</h2>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col xs="12">
                  <br />
                  <v-alert v-if="sendemail" type="success">
                    E-mail de alteração de senha enviado com sucesso!
                  </v-alert>
                  <v-alert v-if="errorReset" type="error">
                    {{ errorReset }}
                  </v-alert>
                  <v-btn
                    :disabled="sendemail"
                    color="info"
                    :loading="loadingResetPass"
                    @click="sendEmailReset"
                    >Enviar email de alteração de senha</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="text-center" cols="12">
          <v-btn @click="saveUser" :loading="saving" color="success"
            >Salvar</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark text @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Vue from 'vue'
import appApi from '../../plugins/api'
import FindCep from '../../plugins/find-cep'

export default {
  components: {},
  data: function() {
    return {
      model: {
        address: {}
      },
      snackbar: {
        show: false,
        color: 'success',
        text: ''
      },
      password: {
        password: null,
        new_password: null,
        confirm_password: null
      },
      saving: false,
      previewImage: null,
      userPicture: null,
      loadingResetPass: false,
      sendemail: false,
      errorReset: null
    }
  },

  computed: {},

  mounted: function() {
    appApi.getAuthUser().then(result => {
      if (!result.data.address) {
        result.data.address = {}
      }
      this.model = result.data

      this.previewImage = this.model.picture
    })
  },

  methods: {
    saveUser() {
      this.saving = true
      delete this.model.errors

      appApi
        .putUserUser(this.model.id, {
          name: this.model.name,
          email: this.model.email
        })
        .then(result => {
          return this.saveAddress()
        })
        .then(result => {
          return this.savePicture()
        })
        .then(result => {
          this.snackbar.show = true
          this.snackbar.color = 'success'
          this.snackbar.text = 'Salvo com sucesso'
        })
        .catch(err => {
          this.saving = false
          this.snackbar.show = true
          this.snackbar.color = 'error'
          this.snackbar.text = 'Não foi possível salvar, verifique os erros.'
          if (err.response && err.response.status == 400) {
            this.model.errors = {}
            err.response.data.forEach(element => {
              this.model.errors[element.field] = true
            })
          }
        })
        .finally(_ => {
          this.saving = false
        })
    },

    saveAddress() {
      let userAddress = JSON.parse(JSON.stringify(this.model.address))
      if (userAddress.zipcode) {
        userAddress.zipcode = userAddress.zipcode.replace(/\D/g, '')
      }

      appApi.putUserAddress(userAddress).then(_ => {})
    },

    async savePicture() {
      try {
        if (!this.userPicture) {
          this.saving = false
          return
        }
        let formData = new FormData()
        formData.append('picture', this.userPicture)

        return appApi.putUsersPicture(formData)
      } catch (error) {
        throw error
      }
    },

    sendEmailReset() {
      this.loadingResetPass = true
      this.errorReset = null
      appApi
        .postResetPassword({
          email: this.model.email
        })
        .then(result => {
          this.loadingResetPass = false
          this.sendemail = true
        })
        .catch(err => {
          this.loadingResetPass = false
          this.errorReset = 'Não foi possível enviar e-mail.'
        })
    },

    getPreviewImage(fileInput) {
      if (fileInput) {
        const reader = new FileReader()
        reader.onload = e => {
          this.previewImage = e.target.result
        }
        reader.readAsDataURL(fileInput)
        this.userPicture = fileInput
      } else {
        this.previewImage = null
        this.userPicture = null
      }
    },

    findCep(zipcode) {
      if (zipcode.replace(/\D/g, '').length === 8) {
        var that = this
        FindCep.getAddress(zipcode.replace(/\D/g, ''), function(result) {
          let address = {}
          Vue.set(that.model.address, 'state', result.address_state)
          Vue.set(that.model.address, 'city', result.address_city)
          Vue.set(
            that.model.address,
            'neighborhood',
            result.address_neighborhood
          )
          Vue.set(that.model.address, 'address', result.address_street)
        })
      }
    }
  }
}
</script>
<style scoped lang="css">
#pageProfile {
  position: relative;
}

.profile-photo {
  height: 280px;
  overflow: auto;
}

@media only screen and (max-width: 500px) {
  .profile-photo {
    height: 200px;
  }
}
</style>
